export const PLANS_IDS = {
  AEPlanKilometros: 'AEPlanKilometros',
  AERoboTotal: 'AERoboTotal',
  AETodoRiesgoRedPreferente: 'AETodoRiesgoRedPreferente',
  AETodoRiesgo1: 'AETodoRiesgo1',
  AUTOEfectivoMontoFijo: 'AUTOEfectivoMontoFijo',
};
